// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"wZ-z","categoryName":"xZ-z","categoryImage":"yZ-z","categoryContent":"zZ-z","bottomAligned":"AZ-z"};